import React from 'react';
import PropTypes from 'prop-types';
import { SHADOW_BANNER_COPY, SHADOW_BANNER_TITLE } from './adapters';

/*
 * PROD-7828 R5 (D-11) — the backend decides visibility (`shadow_banner`: OPEN month + workers off);
 * the copy is fixed so nobody reads these numbers as payroll truth.
 */
const ShadowBanner = ({ show }) =>
  show ? (
    <div className="tp-banner tp-banner-warn">
      <b>{SHADOW_BANNER_TITLE}</b> {SHADOW_BANNER_COPY}
    </div>
  ) : null;

ShadowBanner.propTypes = { show: PropTypes.bool };
ShadowBanner.defaultProps = { show: false };

export default ShadowBanner;
